import { PayloadAction } from '@reduxjs/toolkit';
import { IState } from '../types';
import { INotice } from 'store/features/application/types/notice';

const resetNotice = (
  state: IState,
  { payload }: PayloadAction<Pick<INotice, 'id'>>,
) => {
  state.notice = (state.notice || []).filter(({ id }) => id !== payload.id);
};

export default resetNotice;
